/* eslint-disable complexity */

import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import ActivityIndicator from '../../shared/ActivityIndicator';
import SegmentHeader from '../../shared/SegmentHeader';
import StepperButtons from '../../shared/StepperButtons';

class DigitalSaleOTPPromissory extends PureComponent {
  state = {
    debtorExternalTabOpened: false,
    cosignerExternalTabOpened: false,
    submit: false,
    showOtpValidationModal: false
  };

  currentStep = this.props.routes.indexOf(this.props.location.pathname);
  nextStep = this.currentStep + 1;

  componentDidMount() {
    this.props.setCurrentStep(this.currentStep);
  }

  onSubmit = () => {
    const {
      process,
      contract,
      routes,
      unmaterializedProcessId,
      tempPromissory
    } = this.props;

    this.props.checkDigitalSaleSignedUnmaterializedPromissory(
      unmaterializedProcessId,
      tempPromissory.debtor.date_of_birth,
      contract,
      routes[this.nextStep],
      process
    );
  };

  render() {
    const {
      classes,
      tempPromissory,
      debtorSignUrl,
      orgDataLoading
    } = this.props;
    if (orgDataLoading) {
      return <ActivityIndicator />;
    }

    if (debtorSignUrl && !this.state.debtorExternalTabOpened) {
      window.open(debtorSignUrl, '_blank');
      this.setState({ debtorExternalTabOpened: true });
    }

    const currentUser = { mobile: tempPromissory.debtor.mobile };
    const cosignerUser = tempPromissory.cosigner
      ? { mobile: tempPromissory.cosigner.mobile }
      : null;

    return (
      <div className={classes.container}>
        <Paper className={classes.paper}>
          <div className={classes.segmentHeaderOptions}>
            <SegmentHeader className={classes.segmentHeader}>
              {`Se le enviará un mensaje de texto ${
                cosignerUser ? 'a los números' : 'al número'
              } ${
                cosignerUser
                  ? currentUser.mobile + ' y ' + cosignerUser.mobile
                  : currentUser.mobile
              } `}
            </SegmentHeader>
          </div>
          <div className={classes.item} variant="caption">
            El pagaré está siendo firmado por el usuario en este momento. Al
            completar el proceso, favor continuar presionando
            <span className={classes.headline}>{` Siguiente`}</span>
            {` en esta pantalla`}
          </div>
          <StepperButtons onSubmit={this.onSubmit} goBack={this.props.goBack} />
        </Paper>
      </div>
    );
  }
}

const styles = theme => ({
  container: {
    display: 'flex'
  },
  paper: {
    flexGrow: 1
  },
  form: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-around'
  },
  spacer: {
    flex: 1,
    minHeight: '1px',
    minWidth: '1px'
  },
  item: {
    margin: 20,
    textAlign: 'center'
  },
  headline: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold'
  },
  button: {
    alignSelf: 'flex-end',
    marginTop: 2 * theme.spacing.unit,
    paddingLeft: 8 * theme.spacing.unit,
    paddingRight: 8 * theme.spacing.unit
  },
  segmentHeader: {
    marginTop: 3 * theme.spacing.unit,
    '&:first-of-type': {
      marginTop: 2
    }
  },
  liDivider: {
    listStyleType: 'none'
  },
  segmentHeaderOptions: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#f5f5f5'
  },
  pdf: {
    display: 'flex',
    justifyContent: 'center'
  },
  segmentHeaderOtpV2: {
    marginTop: 3 * theme.spacing.unit,
    '&:first-of-type': {
      marginTop: 5
    },
    width: '100%'
  },
  signButton: {
    margin: 2,
    padding: '8px',
    marginRight: '20px'
  },
  iconRoot: {
    width: '70px',
    height: '70px'
  },
  imageIcon: {
    height: '70%'
  },
  advisoryText: {
    textAlign: 'center'
  },
  bottomOptions: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'center',
    marginTop: '7px'
  }
});

DigitalSaleOTPPromissory.propTypes = PropTypes.exact({
  setCurrentStep: PropTypes.func.isRequired,
  process: PropTypes.object,
  contract: PropTypes.object,
  routes: PropTypes.array.isRequired,
  checkDigitalSaleSignedUnmaterializedPromissory: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  unmaterializedProcessId: PropTypes.string.isRequired,
  tempPromissory: PropTypes.object.isRequired,
  orgDataLoading: PropTypes.bool.isRequired,
  goBack: PropTypes.func.isRequired,
  debtorSignUrl: PropTypes.string.isRequired
});

export default withStyles(styles)(DigitalSaleOTPPromissory);
